import { sorted } from "helpers";
import type { ScrapEyeRecordingPosition } from "src/store/api/generatedApi";
import { alpha, Box, Theme, Tooltip, Typography } from "@mui/material";

export const positionColours = (
  positions: ScrapEyeRecordingPosition[],
  theme: Theme
) => {
  const colours = Object.values(theme.palette.data);
  return new Map(
    sorted(
      sorted(positions, (position) => position.id),
      (position) => position.location_name
    ).map((position, index) => [
      position.id,
      colours[index % colours.length] ?? theme.palette.data.blue,
    ])
  );
};

export const PositionBadge = ({
  colour,
  name,
  location,
}: {
  colour: string;
  name: string;
  location: string;
}) => {
  return (
    <Tooltip title={`${location} / ${name}`}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          px: 0.5,
          bgcolor: alpha(colour, 0.1),
          borderLeft: 3,
          borderColor: colour,
          minWidth: 0,
        }}
      >
        <Typography variant="caption" color="text.primary" noWrap>
          {name}
        </Typography>
      </Box>
    </Tooltip>
  );
};
